export default __webpack_public_path__ + "static/media/PlayHoverIcon.b190a481.svg";